// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.orange[data-v-00d1574e] {
  background-color: #ff7300 !important;
  border-color: #ff7300 !important;
  color: white !important;
}

/* ================= Centrar switches ================= */
.switch-centrado[data-v-00d1574e] .form-check.form-switch {
  padding-left: 0 !important;
  margin-bottom: 0 !important;
}
.switch-centrado[data-v-00d1574e] .form-check-input {
  margin-left: 0 !important;
  float: none !important;
  cursor: pointer;
}

/* ================= CSS Botones Naranjas ================= */
.custom-orange-group .btn-primary[data-v-00d1574e] {
  background-color: #ff7300 !important;
  border-color: #ff7300 !important;
  color: white !important;
}
.custom-orange-group .btn-outline-primary[data-v-00d1574e] {
  color: #ff7300 !important;
  border-color: #ff7300 !important;
  background-color: transparent !important;
}
.custom-orange-group .btn-outline-primary[data-v-00d1574e]:hover {
  background-color: #ff7300 !important;
  color: white !important;
}

/* ================= CSS Tablas ================= */
.cabecera-agrupada th[data-v-00d1574e] {
  padding-top: 15px;
  padding-bottom: 5px;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.cabecera-agrupada th.bg-light[data-v-00d1574e], .cabecera-agrupada th.bg-channels[data-v-00d1574e] {
  border-bottom: 2px solid #adb5bd !important;
}
.cabecera-secundaria th[data-v-00d1574e] {
  border-top: none !important;
}
.espacio-separacion[data-v-00d1574e] {
  padding-left: 30px !important;
}
.separador-vertical[data-v-00d1574e] {
  border-left: 2px solid #ccc !important;
}
.bg-channels[data-v-00d1574e] {
  background-color: #f8f9fa;
}
.text-center[data-v-00d1574e] {
  text-align: center;
}
#dashboard[data-v-00d1574e] {
  min-width: 0;
  max-width: 100%;
}
#dashboard > section.row[data-v-00d1574e] {
  min-width: 0;
  max-width: 100%;
}
#dashboard .col-xl-12[data-v-00d1574e] {
  min-width: 0;
  max-width: 100%;
}
@media only screen and (max-width: 992px) {
.tabla-subcriptores table[data-v-00d1574e],
  .tabla-subcriptores thead[data-v-00d1574e],
  .tabla-subcriptores tbody[data-v-00d1574e],
  .tabla-subcriptores th[data-v-00d1574e],
  .tabla-subcriptores td[data-v-00d1574e],
  .tabla-subcriptores tr[data-v-00d1574e] {
    display: block;
}
.tabla-subcriptores thead tr[data-v-00d1574e] {
    position: absolute;
    top: -9999px;
    left: -9999px;
}
.tabla-subcriptores tr[data-v-00d1574e] {
    border: 1px solid #ccc;
    margin-bottom: 15px;
    background: #fff;
}
.tabla-subcriptores td[data-v-00d1574e] {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50% !important;
    white-space: normal;
    text-align: left;
    min-height: 45px;
    display: flex;
    align-items: center;
}
.tabla-subcriptores td[data-v-00d1574e]:before {
    position: absolute;
    top: 50%;
    left: 15px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    text-align: left;
    font-weight: bold;
    transform: translateY(-50%);
    content: attr(data-title);
}
.espacio-separacion[data-v-00d1574e] {
    padding-left: 50% !important;
}
.separador-vertical[data-v-00d1574e] {
    border-left: none !important;
}
}
.toggle-button[data-v-00d1574e]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.tabla-scroll[data-v-00d1574e] {
  display: block;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.tabla-scroll > .tabla-subcriptores[data-v-00d1574e] {
  table-layout: auto;
  width: max-content;
  min-width: 100%;
}
#tabla-suscriptores col[data-v-00d1574e]:nth-child(1),
#tabla-suscriptores col[data-v-00d1574e]:nth-child(2),
#tabla-subcriptores-nuevo col[data-v-00d1574e]:nth-child(1),
#tabla-subcriptores-nuevo col[data-v-00d1574e]:nth-child(2) {
  width: 75px;
}
#tabla-suscriptores col[data-v-00d1574e]:nth-child(3),
#tabla-subcriptores-nuevo col[data-v-00d1574e]:nth-child(3),
#tabla-solicitudes col[data-v-00d1574e]:nth-child(3),
#tabla-historial col[data-v-00d1574e]:nth-child(3),
#tabla-whitelist col[data-v-00d1574e]:nth-child(2) {
  min-width: 22ch;
  width: 30ch;
}
#tabla-suscriptores td:nth-child(3) span[data-v-00d1574e] {
  display: block;
  max-width: 30ch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#tabla-suscriptores col[data-v-00d1574e]:nth-child(4),
#tabla-subcriptores-nuevo col[data-v-00d1574e]:nth-child(4),
#tabla-solicitudes col[data-v-00d1574e]:nth-child(4),
#tabla-historial col[data-v-00d1574e]:nth-child(4),
#tabla-whitelist col[data-v-00d1574e]:nth-child(3) {
  width: 150px;
}
#tabla-suscriptores col[data-v-00d1574e]:nth-child(5) {
  min-width: 18ch;
  width: 18ch;
}
#tabla-suscriptores col[data-v-00d1574e]:nth-child(6),
#tabla-suscriptores col[data-v-00d1574e]:nth-child(7),
#tabla-suscriptores col[data-v-00d1574e]:nth-child(8),
#tabla-suscriptores col[data-v-00d1574e]:nth-child(9),
#tabla-suscriptores col[data-v-00d1574e]:nth-child(10),
#tabla-subcriptores-nuevo col[data-v-00d1574e]:nth-child(5),
#tabla-subcriptores-nuevo col[data-v-00d1574e]:nth-child(6),
#tabla-subcriptores-nuevo col[data-v-00d1574e]:nth-child(7),
#tabla-subcriptores-nuevo col[data-v-00d1574e]:nth-child(8),
#tabla-solicitudes col[data-v-00d1574e]:nth-child(5),
#tabla-solicitudes col[data-v-00d1574e]:nth-child(6),
#tabla-solicitudes col[data-v-00d1574e]:nth-child(7),
#tabla-solicitudes col[data-v-00d1574e]:nth-child(8) {
  width: 110px;
}
#tabla-solicitudes col[data-v-00d1574e]:nth-child(1),
#tabla-solicitudes col[data-v-00d1574e]:nth-child(2),
#tabla-historial col[data-v-00d1574e]:nth-child(1) {
  min-width: 120px;
}
#tabla-suscriptores .cabecera-secundaria th[data-v-00d1574e]:nth-child(1),
#tabla-suscriptores .cabecera-secundaria th[data-v-00d1574e]:nth-child(2),
#tabla-suscriptores .cabecera-secundaria th[data-v-00d1574e]:nth-child(6),
#tabla-suscriptores .cabecera-secundaria th[data-v-00d1574e]:nth-child(7),
#tabla-suscriptores .cabecera-secundaria th[data-v-00d1574e]:nth-child(8),
#tabla-suscriptores .cabecera-secundaria th[data-v-00d1574e]:nth-child(9),
#tabla-suscriptores .cabecera-secundaria th[data-v-00d1574e]:nth-child(10),
#tabla-suscriptores td[data-v-00d1574e]:nth-child(1),
#tabla-suscriptores td[data-v-00d1574e]:nth-child(2),
#tabla-suscriptores td[data-v-00d1574e]:nth-child(6),
#tabla-suscriptores td[data-v-00d1574e]:nth-child(7),
#tabla-suscriptores td[data-v-00d1574e]:nth-child(8),
#tabla-suscriptores td[data-v-00d1574e]:nth-child(9),
#tabla-suscriptores td[data-v-00d1574e]:nth-child(10),
#tabla-subcriptores-nuevo .cabecera-secundaria th[data-v-00d1574e]:nth-child(1),
#tabla-subcriptores-nuevo .cabecera-secundaria th[data-v-00d1574e]:nth-child(2),
#tabla-subcriptores-nuevo .cabecera-secundaria th[data-v-00d1574e]:nth-child(5),
#tabla-subcriptores-nuevo .cabecera-secundaria th[data-v-00d1574e]:nth-child(6),
#tabla-subcriptores-nuevo .cabecera-secundaria th[data-v-00d1574e]:nth-child(7),
#tabla-subcriptores-nuevo .cabecera-secundaria th[data-v-00d1574e]:nth-child(8),
#tabla-subcriptores-nuevo td[data-v-00d1574e]:nth-child(1),
#tabla-subcriptores-nuevo td[data-v-00d1574e]:nth-child(2),
#tabla-subcriptores-nuevo td[data-v-00d1574e]:nth-child(5),
#tabla-subcriptores-nuevo td[data-v-00d1574e]:nth-child(6),
#tabla-subcriptores-nuevo td[data-v-00d1574e]:nth-child(7),
#tabla-subcriptores-nuevo td[data-v-00d1574e]:nth-child(8) {
  text-align: center;
}
.tabla-subcriptores th[data-v-00d1574e],
.tabla-subcriptores td[data-v-00d1574e] {
  white-space: nowrap;
  vertical-align: middle;
}
.tabla-subcriptores td[data-v-00d1574e] {
  padding: 10px 8px;
}
.tabla-subcriptores[data-v-00d1574e] .btn {
  white-space: nowrap;
}
.tabla-subcriptores[data-v-00d1574e] .form-control {
  margin: 0;
  width: 100%;
  min-width: 12ch;
  height: 38px;
  box-sizing: border-box;
}
@media only screen and (max-width: 992px) {
.tabla-scroll[data-v-00d1574e] {
    overflow-x: visible;
    max-width: none;
}
.tabla-scroll > .tabla-subcriptores[data-v-00d1574e] {
    table-layout: auto;
    width: 100%;
    min-width: 0;
}
.tabla-subcriptores colgroup[data-v-00d1574e] {
    display: none;
}
.tabla-subcriptores th[data-v-00d1574e], .tabla-subcriptores td[data-v-00d1574e] {
    width: 100% !important;
    white-space: normal;
}
.tabla-subcriptores .toggle-container[data-v-00d1574e] {
    margin-left: 0 !important;
}
.tabla-subcriptores td[data-v-00d1574e] {
    justify-content: flex-start;
}
.tabla-subcriptores[data-v-00d1574e] .form-control {
    width: 90%;
    min-width: 0;
}
}
`, "",{"version":3,"sources":["webpack://./src/app/components/Suscriptores.vue"],"names":[],"mappings":";AA+qCA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,wCAAwC;AAC1C;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,mDAAmD;AACnD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;AAEA;EACE,2CAA2C;AAC7C;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,sCAAsC;AACxC;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;AAEA;AACE;;;;;;IAME,cAAc;AAChB;AAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACf;AAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AAClB;AAEA;IACE,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACrB;AAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;AAC3B;AAEA;IACE,4BAA4B;AAC9B;AAEA;IACE,4BAA4B;AAC9B;AACF;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AAEA;;;;EAIE,WAAW;AACb;AAEA;;;;;EAKE,eAAe;EACf,WAAW;AACb;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AAEA;;;;;EAKE,YAAY;AACd;AAEA;EACE,eAAe;EACf,WAAW;AACb;AAEA;;;;;;;;;;;;;EAaE,YAAY;AACd;AAEA;;;EAGE,gBAAgB;AAClB;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,kBAAkB;AACpB;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;AAEA;AACE;IACE,mBAAmB;IACnB,eAAe;AACjB;AAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;AACd;AAEA;IACE,aAAa;AACf;AAEA;IACE,sBAAsB;IACtB,mBAAmB;AACrB;AAEA;IACE,yBAAyB;AAC3B;AAEA;IACE,2BAA2B;AAC7B;AAEA;IACE,UAAU;IACV,YAAY;AACd;AACF","sourcesContent":["\n\n.orange {\n  background-color: #ff7300 !important;\n  border-color: #ff7300 !important;\n  color: white !important;\n}\n\n/* ================= Centrar switches ================= */\n.switch-centrado :deep(.form-check.form-switch) {\n  padding-left: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.switch-centrado :deep(.form-check-input) {\n  margin-left: 0 !important;\n  float: none !important;\n  cursor: pointer;\n}\n\n/* ================= CSS Botones Naranjas ================= */\n.custom-orange-group .btn-primary {\n  background-color: #ff7300 !important;\n  border-color: #ff7300 !important;\n  color: white !important;\n}\n\n.custom-orange-group .btn-outline-primary {\n  color: #ff7300 !important;\n  border-color: #ff7300 !important;\n  background-color: transparent !important;\n}\n\n.custom-orange-group .btn-outline-primary:hover {\n  background-color: #ff7300 !important;\n  color: white !important;\n}\n\n/* ================= CSS Tablas ================= */\n.cabecera-agrupada th {\n  padding-top: 15px;\n  padding-bottom: 5px;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.cabecera-agrupada th.bg-light, .cabecera-agrupada th.bg-channels {\n  border-bottom: 2px solid #adb5bd !important;\n}\n\n.cabecera-secundaria th {\n  border-top: none !important;\n}\n\n.espacio-separacion {\n  padding-left: 30px !important;\n}\n\n.separador-vertical {\n  border-left: 2px solid #ccc !important;\n}\n\n.bg-channels {\n  background-color: #f8f9fa;\n}\n\n.text-center {\n  text-align: center;\n}\n\n#dashboard {\n  min-width: 0;\n  max-width: 100%;\n}\n\n#dashboard > section.row {\n  min-width: 0;\n  max-width: 100%;\n}\n\n#dashboard .col-xl-12 {\n  min-width: 0;\n  max-width: 100%;\n}\n\n@media only screen and (max-width: 992px) {\n  .tabla-subcriptores table,\n  .tabla-subcriptores thead,\n  .tabla-subcriptores tbody,\n  .tabla-subcriptores th,\n  .tabla-subcriptores td,\n  .tabla-subcriptores tr {\n    display: block;\n  }\n\n  .tabla-subcriptores thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  .tabla-subcriptores tr {\n    border: 1px solid #ccc;\n    margin-bottom: 15px;\n    background: #fff;\n  }\n\n  .tabla-subcriptores td {\n    border: none;\n    border-bottom: 1px solid #eee;\n    position: relative;\n    padding-left: 50% !important;\n    white-space: normal;\n    text-align: left;\n    min-height: 45px;\n    display: flex;\n    align-items: center;\n  }\n\n  .tabla-subcriptores td:before {\n    position: absolute;\n    top: 50%;\n    left: 15px;\n    width: 45%;\n    padding-right: 10px;\n    white-space: nowrap;\n    text-align: left;\n    font-weight: bold;\n    transform: translateY(-50%);\n    content: attr(data-title);\n  }\n\n  .espacio-separacion {\n    padding-left: 50% !important;\n  }\n\n  .separador-vertical {\n    border-left: none !important;\n  }\n}\n\n.toggle-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.tabla-scroll {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.tabla-scroll > .tabla-subcriptores {\n  table-layout: auto;\n  width: max-content;\n  min-width: 100%;\n}\n\n#tabla-suscriptores col:nth-child(1),\n#tabla-suscriptores col:nth-child(2),\n#tabla-subcriptores-nuevo col:nth-child(1),\n#tabla-subcriptores-nuevo col:nth-child(2) {\n  width: 75px;\n}\n\n#tabla-suscriptores col:nth-child(3),\n#tabla-subcriptores-nuevo col:nth-child(3),\n#tabla-solicitudes col:nth-child(3),\n#tabla-historial col:nth-child(3),\n#tabla-whitelist col:nth-child(2) {\n  min-width: 22ch;\n  width: 30ch;\n}\n\n#tabla-suscriptores td:nth-child(3) span {\n  display: block;\n  max-width: 30ch;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#tabla-suscriptores col:nth-child(4),\n#tabla-subcriptores-nuevo col:nth-child(4),\n#tabla-solicitudes col:nth-child(4),\n#tabla-historial col:nth-child(4),\n#tabla-whitelist col:nth-child(3) {\n  width: 150px;\n}\n\n#tabla-suscriptores col:nth-child(5) {\n  min-width: 18ch;\n  width: 18ch;\n}\n\n#tabla-suscriptores col:nth-child(6),\n#tabla-suscriptores col:nth-child(7),\n#tabla-suscriptores col:nth-child(8),\n#tabla-suscriptores col:nth-child(9),\n#tabla-suscriptores col:nth-child(10),\n#tabla-subcriptores-nuevo col:nth-child(5),\n#tabla-subcriptores-nuevo col:nth-child(6),\n#tabla-subcriptores-nuevo col:nth-child(7),\n#tabla-subcriptores-nuevo col:nth-child(8),\n#tabla-solicitudes col:nth-child(5),\n#tabla-solicitudes col:nth-child(6),\n#tabla-solicitudes col:nth-child(7),\n#tabla-solicitudes col:nth-child(8) {\n  width: 110px;\n}\n\n#tabla-solicitudes col:nth-child(1),\n#tabla-solicitudes col:nth-child(2),\n#tabla-historial col:nth-child(1) {\n  min-width: 120px;\n}\n\n#tabla-suscriptores .cabecera-secundaria th:nth-child(1),\n#tabla-suscriptores .cabecera-secundaria th:nth-child(2),\n#tabla-suscriptores .cabecera-secundaria th:nth-child(6),\n#tabla-suscriptores .cabecera-secundaria th:nth-child(7),\n#tabla-suscriptores .cabecera-secundaria th:nth-child(8),\n#tabla-suscriptores .cabecera-secundaria th:nth-child(9),\n#tabla-suscriptores .cabecera-secundaria th:nth-child(10),\n#tabla-suscriptores td:nth-child(1),\n#tabla-suscriptores td:nth-child(2),\n#tabla-suscriptores td:nth-child(6),\n#tabla-suscriptores td:nth-child(7),\n#tabla-suscriptores td:nth-child(8),\n#tabla-suscriptores td:nth-child(9),\n#tabla-suscriptores td:nth-child(10),\n#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(1),\n#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(2),\n#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(5),\n#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(6),\n#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(7),\n#tabla-subcriptores-nuevo .cabecera-secundaria th:nth-child(8),\n#tabla-subcriptores-nuevo td:nth-child(1),\n#tabla-subcriptores-nuevo td:nth-child(2),\n#tabla-subcriptores-nuevo td:nth-child(5),\n#tabla-subcriptores-nuevo td:nth-child(6),\n#tabla-subcriptores-nuevo td:nth-child(7),\n#tabla-subcriptores-nuevo td:nth-child(8) {\n  text-align: center;\n}\n\n.tabla-subcriptores th,\n.tabla-subcriptores td {\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.tabla-subcriptores td {\n  padding: 10px 8px;\n}\n\n.tabla-subcriptores :deep(.btn) {\n  white-space: nowrap;\n}\n\n.tabla-subcriptores :deep(.form-control) {\n  margin: 0;\n  width: 100%;\n  min-width: 12ch;\n  height: 38px;\n  box-sizing: border-box;\n}\n\n@media only screen and (max-width: 992px) {\n  .tabla-scroll {\n    overflow-x: visible;\n    max-width: none;\n  }\n\n  .tabla-scroll > .tabla-subcriptores {\n    table-layout: auto;\n    width: 100%;\n    min-width: 0;\n  }\n\n  .tabla-subcriptores colgroup {\n    display: none;\n  }\n\n  .tabla-subcriptores th, .tabla-subcriptores td {\n    width: 100% !important;\n    white-space: normal;\n  }\n\n  .tabla-subcriptores .toggle-container {\n    margin-left: 0 !important;\n  }\n\n  .tabla-subcriptores td {\n    justify-content: flex-start;\n  }\n\n  .tabla-subcriptores :deep(.form-control) {\n    width: 90%;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
